import { render } from "./license-details-modal.vue?vue&type=template&id=f3c7ca3e"
import script from "./license-details-modal.vue?vue&type=script&lang=js"
export * from "./license-details-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__